import { FC } from 'react';
import graphql from 'babel-plugin-relay/macro';
import { useFragment } from 'react-relay';

import Stack from '@mui/material/Stack';
import Section from 'components/Section';
import TextField from 'components/TextField';
import PackageStatusSelect from 'components/PackageStatusSelect';
import CitySelect from 'components/CitySelect';

import { PackageEditMainGeneral_data$key } from '__generated__/PackageEditMainGeneral_data.graphql';

type Props = {
  data: PackageEditMainGeneral_data$key;
};

const PackageEditMainGeneral: FC<Props> = props => {
  const data = useFragment(
    graphql`
      fragment PackageEditMainGeneral_data on Query {
        ...CitySelect_data
      }
    `,
    props.data
  );

  return (
    <Section id="general" title="Bendra informacija">
      <Stack spacing={4}>
        <TextField fullWidth name="name" label="Pavadinimas" />
        <PackageStatusSelect name="status" label="Pasiūlymo būklė" />
        <CitySelect name="city" label="Miestas" data={data} />

        <TextField
          name="validBeforeTripStartDays"
          label="Galioja iki"
          helperText="Dienos iki kelionės pradžios"
        />
      </Stack>
    </Section>
  );
};

export default PackageEditMainGeneral;
